export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
